import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ToggleComponent } from './toggle.component';
import { ToggleButtonComponent } from './toggle-button.component';
import { ToggleOffComponent } from './toggle-off.component';
import { ToggleOnComponent } from './toggle-on.component';

@NgModule({
  imports: [
  CommonModule
  ],
  declarations: [
  ToggleComponent,
  ToggleButtonComponent,
  ToggleOffComponent,
  ToggleOnComponent,
  ],
  exports: [
  ToggleComponent,
  ToggleButtonComponent,
  ToggleOffComponent,
  ToggleOnComponent,
  ]
  })
export class ToggleModule { }
